import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker  } from '@mui/x-date-pickers/DateTimePicker';

import Moment from 'react-moment';
import moment from 'moment';

import { makeStyles } from '@mui/styles'; 


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class  AddSchedulebox extends Component {

  constructor(props) {
      super(props)
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
      this.state = {
		  
		   open:false,title:'',sc_id:0,errormessage:'',erropen:false,branchdata:[],branch:'',branchlabel:'Select Branch',staffdata:[],staff:'',stafflabel:'Select Staff',scdate:Date.now(),scdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
	  }
      
  }

handfrChanges = (Dayjs) => {
	
	
	  var month="";
	
	 var date=new Date(Dayjs);
	 var todaytime=date.getHours() + ":" + date.getMinutes()+":00"; 
	 alert(date.getMonth())
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ scdate:date,
scdate1:date.getFullYear() + '-' + month + '-' +date.getDate()+ ' ' +date.getHours() + ":" + date.getMinutes()+":00"
	 })	
  }


 Schedulegetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxschedule.php?action=getall&sc_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){		
	
    this.setState({ 
     
      sc_id:resp.data[0].sc_id,
	  staff: resp.data[0].sc_st_id,
      branch: resp.data[0].sc_bm_id,	
	 scdate:resp.data[0].sc_date,
	 scdate1:resp.data[0].sc_date,
    });
  }  
});
	
  }else{
	 this.setState({  
	  sc_id:0,
	  staff: '',
      branch: '', 
	 scdate: '',   
	 scdate1:'',	 
	  }); 
 }
  
    }
   

handleClickOpen = (e) => {

  this.setState({open:!this.state.open, staff:'',branch:'',scdate:'',scdate1:'',errormessage:'',erropen:false,
	  });	
		
	this.Schedulegetdata();	
		this.branchbind();
		this.staffbind();
};
myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});
  }
  


 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


branchbind(){

    axios.get(Serverurl+'ajaxbranch.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let BranchApi = resp.data.map(row => {
                      
          return {value: row.bm_id, display:row.bm_name}
        });
		
		 this.setState({
          branchdata: [{value: '0', display:'Select Branch'}].concat(BranchApi)
        },()=>{console.log(this.state.branchdata)});
      }).then(data => {
		 
        
      
		
       
      }) 
    
     


}

staffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let StaffApi = resp.data.map(row => {
                      
          return {value: row.st_id, display:row.st_name}
        });
		
		 this.setState({
          staffdata: [{value: '0', display:'Select Staff'}].concat(StaffApi)
        },()=>{console.log(this.state.staffdata)});
      }).then(data => {
		 
        
      
		
       
      }) 
    
     


}

handleClose = (e) => {
	
	
 let staff = this.state.staff;
 let branch=this.state.branch;
let scdate1=this.state.scdate1;


if(staff==="")
{
	
	this.setState({errormessage:"Please Select Staff",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(branch==="")
{
	
	this.setState({errormessage:"Please Select Branch",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

		


   var formData = new FormData();
  
  
   if(this.state.sc_id==0)
	  {
		  formData.append('sc_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('sc_id',this.state.sc_id)
		
      }	  

        formData.append('action','insertorupdate') 
		formData.append('sc_st_id',staff)
		formData.append('sc_bm_id',branch)	
		formData.append('sc_date',scdate1)			
		formData.append('userid',localStorage.getItem("AYLuserid"))
		  
		axios.post(Serverurl+"ajaxschedule.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
	{ 

		
		

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
	 
  } 
	
	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" aria-labelledby="form-dialog-title" className="schedloadspanel">
      <DialogTitle id="form-dialog-title"> 
	  
	 <h2> Schedule </h2>
	  
	  </DialogTitle>
      <DialogContent>
	  
<div className="formlists">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
	<p> <span className="validation">*</span> Staff</p>
	
	<p><FormControl  className="stadrps">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.stafflabel, value: this.state.staff }}
          onChange={this.myChangeHandler}
          id="staff"
		   value={this.state.staff}
		  name="staff"
		
		
        >
		{this.state.staffdata.map(st => (
            <option  
            
              value={st.value}
            >
              {st.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>	
	
	<p> <span className="validation">*</span> Branch</p>
	
	<p><FormControl  className="stadrps">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branch }}
          onChange={this.myChangeHandler}
          id="branch"
		   value={this.state.branch}
		  name="branch"
		
		
        >
		{this.state.branchdata.map(branch => (
            <option  
            
              value={branch.value}
            >
              {branch.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
						  
	
	 <p> Date</p>
		<p>
		
		<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
        <DemoItem label="Followup Date">
          <DateTimePicker id="scdate1" name="scdate1"
		  value={this.state.scdate1 || dayjs(moment().toDate(),1)} onChange={this.handfrChanges}
		
            views={['year', 'month', 'day','hh:mm' ]}
		  />
        </DemoItem>
       
      </DemoContainer>
    </LocalizationProvider>
		</p>
		<div className="actionbtn">
<div className="cancelbtn">	  
        <Button className="frmSecondarybtn" onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button className="frmPrimarybtn" onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
	</div>		 
	 </DialogContent>
      
    </Dialog>
</React.Fragment>

) 
}
} 
  









